import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseCreateResource } from '../../utils/types';

type LineItemInput = Partial<NonNullable<TrpcInputs['createLineItem']>>;
type LineItemOutput = Partial<TrpcOutputs['createLineItem']>;

type CreateLineItemMutate = MutateFunction<LineItemInput, LineItemOutput>;
type UseCreateLineItem = UseCreateResource<LineItemInput, LineItemOutput>;

export const useCreateLineItem = (quoteVariantId?: number): UseCreateLineItem => {
  const { mutateAsync: createAsync, isLoading, error } = trpc.createLineItem.useMutation();

  const create: CreateLineItemMutate = (args) => createAsync({ quote_variant_id: quoteVariantId, ...args } as any);

  const createDefault: CreateLineItemMutate = (args) =>
    createAsync({
      quote_variant_id: quoteVariantId,
      ...args,
    } as any);

  return {
    create,
    createDefault,
    isLoading,
    error: error?.message,
  };
};
